import React, { Component } from 'react';
import './login.css';
import inhand from '../../assets/images/inhand.png';
import { LockOutlined, UserOutlined } from '@ant-design/icons';
import { Form } from '@ant-design/compatible';
import '@ant-design/compatible/assets/index.css';
import { Input, Button, message } from 'antd';
import { Redirect } from 'react-router-dom';
import { login } from '../../redux/actions';
import { connect } from 'react-redux';
const Item = Form.Item;

class Login extends Component {
  handleSubmit = (event) => {
    event.preventDefault();
    this.props.form.validateFields(async (err, values) => {
      const { username, password } = values;
      if (!err) {
        this.props.login(username, password);
      } else {
        message.error('校验失败');
      }
    });
  };
  validataPwd = (rule, value, callback) => {
    if (!value) {
      callback('密码必须输入');
    } else {
      callback();
    }
  };
  render() {
    const user = this.props.user;
    if (user && user.uid) {
      return <Redirect to="/admin"></Redirect>;
    }

    const form = this.props.form;
    const { getFieldDecorator } = form;
    return (
      <div className="login">
        <header className="login-header">
          <img src={inhand} alt="" />
        </header>
        <section className="login-content">
          <h2>用户登录</h2>
          <Form
            onSubmit={this.handleSubmit}
            className="login-form"
            wrapperCol={{ offset: 4 }}>
            <Item>
              {getFieldDecorator('username', {
                rules: [
                  {
                    required: true,
                    message: '请输入用户名'
                  },
                ],
              })(
                <Input
                  prefix={<UserOutlined style={{ color: 'rgba(0,0,0,.25)' }} />}
                  placeholder="Username"
                />
              )}
            </Item>
            <Item>
              {getFieldDecorator('password', {
                rules: [
                  {
                    validator: this.validataPwd,
                  },
                ],
              })(
                <Input
                  prefix={<LockOutlined style={{ color: 'rgba(0,0,0,.25)' }} />}
                  type="password"
                  placeholder="Password"
                />
              )}
            </Item>
            <Item>
              <Button
                type="primary"
                htmlType="submit"
                size='large'
                className="login-form-button">
                登录
              </Button>
            </Item>
          </Form>
        </section>
      </div>
    );
  }
}

const WrapLogin = Form.create()(Login);

export default connect((state) => ({ user: state.user }), {
  login,
})(WrapLogin);
